import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function LandingNav() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-white/40">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home">
          <span className="w-8 h-8 rounded-[10px] bg-[#3A8FA5] flex items-center justify-center text-white font-bold text-base">Q</span>
          <span className="text-[18px] font-bold tracking-tight text-[#1E3A5F]">Questiomed</span>
        </Link>
        <div className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#features" className="link-underline text-[#5F758F]">Fonctionnalités</a>
          <a href="/#for-who" className="link-underline text-[#5F758F]">Pour qui ?</a>
          <a href="/#security" className="link-underline text-[#5F758F]">Sécurité</a>
          <a href="/#pricing" className="link-underline text-[#5F758F]">Tarifs</a>
          <a href="/#faq" className="link-underline text-[#5F758F]">FAQ</a>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/login" data-testid="nav-login">
            <Button variant="ghost" className="rounded-full text-[#1E3A5F] hover:bg-[#E1E9F0]">Se connecter</Button>
          </Link>
          <Link to="/signup" data-testid="nav-signup">
            <Button className="rounded-full bg-[#3A8FA5] hover:bg-[#164E5F] text-white">Créer un compte</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
